import { $themeConfig } from "@themeConfig";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import { checkDateToFormat } from "@/utils/format";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "../../router";
import app from "@/main";
export default {
  namespaced: true,
  state: {
    params: {
      search: {},
      page: 1,
      pageSize: 10,
    },
    totalRecords: 0,
    bookingNotes: [],
  },
  getters: {
    getBookingNotes: (state) => {
      return state.bookingNotes;
    },
  },
  mutations: {
    SET_PARAMS(state, payload) {
      state.params = payload;
    },
    SET_BOOKING_NOTES(state, payload) {
      state.bookingNotes = payload;
    },

    SET_BOOKING_NOTES_TOTAL(state, payload) {
      state.totalRecords = payload;
    },
  },
  actions: {
    loadItem({ commit }, params) {
      return new Promise((resolve, reject) => {
        useJwt
          .get("bookingNote", { params: params })
          .then((response) => {
            var mapData = response.data.result.map((e) => {
              e.booking_date = checkDateToFormat(e.booking_date);
              e.eta = checkDateToFormat(e.eta);
              e.etd = checkDateToFormat(e.etd);

              return e;
            });
            commit("SET_BOOKING_NOTES_TOTAL", response.data.meta.total);

            commit("SET_BOOKING_NOTES", mapData);
            resolve(mapData);
          })
          .catch((error) => {
            resolve(false);
          });
      });
    },
  },
};
